import React from 'react'

function ListItems(props) {
    return (
        <div>
            <li>{props.line}</li>
        </div>
    )
}

export default ListItems
